import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { UserAuthorizationContainerComponent } from './user-authorization-container/user-authorization-container.component';

const log = new LoggingService();

export const UserAuthorizationsRoute: Ng2StateDeclaration = {
    // name: 'LeaveRequest.**'
    name: 'userauthorizations',
    url: '/userauthorizations',
    // , loadChildren: () => import('./leave-request.module').then(r => r.LeaveRequestModule)
    data: { requiresAuth: true },
    // params: { process: {} },
    // resolve: [
    //     {
    //         token: 'process',
    //         deps: [Transition, CategoriesService],
    //         resolveFn: processResolver
    //     }
    // ],
    component: UserAuthorizationContainerComponent
};
